export default {
    title: 'Perfil',
    subtitle: 'Gestiona tu información personal y preferencias',
    tabs: {
        preferences: 'Preferencias',
        account: 'Cuenta',
        password: 'Contraseña',
        picture: 'Foto de Perfil',
        companies: 'Empresas',
        integrations: 'Integraciones',
    },
    preferences: {
        language: {
            title: 'Idioma',
            description: 'Selecciona tu idioma preferido para la interfaz',
        },
        theme: {
            title: 'Tema',
            description: 'Elige entre tema claro y oscuro',
        },
    },
    account: {
        title: 'Información de la Cuenta',
        description: 'Actualiza tu información personal',
        legalSection: {
            title: 'Legal',
            description: 'Consulta nuestros Términos y condiciones y la Política de privacidad.',
        },
        firstName: 'Nombre',
        firstNamePlaceholder: 'Ingresa tu nombre',
        lastName: 'Apellido',
        lastNamePlaceholder: 'Ingresa tu apellido',
        email: 'Correo Electrónico',
        emailPlaceholder: 'Ingresa tu dirección de correo electrónico',
        phone: 'Teléfono',
        phonePlaceholder: 'Ingresa tu número de teléfono',
        jobTitle: 'Cargo',
        jobTitlePlaceholder: 'Ingresa tu cargo',
        department: 'Departamento',
        departmentPlaceholder: 'Ingresa tu departamento',
    },
    password: {
        title: 'Cambiar Contraseña',
        description: 'Actualiza la contraseña de tu cuenta',
        currentPassword: 'Contraseña Actual',
        currentPasswordPlaceholder: 'Ingresa tu contraseña actual',
        newPassword: 'Nueva Contraseña',
        newPasswordPlaceholder: 'Ingresa tu nueva contraseña',
        confirmPassword: 'Confirmar Contraseña',
        confirmPasswordPlaceholder: 'Confirma tu nueva contraseña',
        mismatch: 'Las contraseñas no coinciden',
        changePassword: 'Cambiar Contraseña',
    },
    picture: {
        title: 'Foto de Perfil',
        description: 'Sube y gestiona tu foto de perfil',
        global: 'Global (Todas las Empresas)',
        scope: 'Alcance',
        scopeDescription: 'Elige si esta imagen debe ser visible globalmente o solo para una empresa específica',
        selectFile: 'Seleccionar Archivo',
        upload: 'Subir',
        invalidFileType: 'Tipo de archivo no válido. Por favor selecciona una imagen PNG, JPG, JPEG o WEBP.',
        fileTooLarge: 'El tamaño del archivo excede el límite de 5MB.',
    },
    companies: {
        title: 'Empresas',
        description: 'Ver todas las empresas de las que formas parte',
        noCompanies: 'No formas parte de ninguna empresa',
        primary: 'Principal',
        noType: 'Sin Tipo',
        types: {
            sender: 'Remitente',
            receiver: 'Destinatario',
            freight_forwarder: 'Agente de Carga',
            port_authority: 'Autoridad Portuaria',
            carrier: 'Transportista',
            customs_broker: 'Agente Aduanero',
            insurance_provider: 'Proveedor de Seguros',
        },
        role: {
            super_admin: 'Super Administrador',
            company_admin: 'Administrador de Empresa',
            operator: 'Operador',
            viewer: 'Visualizador',
        },
    },
    integrations: {
        title: 'Integraciones de Correo',
        description: 'Conecta tus cuentas personales de Gmail o Outlook a Eve Mind',
        connectedAccounts: 'Cuentas Conectadas',
        connectNew: 'Conectar Nueva Cuenta',
        connectGmail: 'Conectar Gmail',
        connectOutlook: 'Conectar Outlook',
        confirmDisconnect: '¿Estás seguro de que deseas desconectar esta cuenta de correo?',
        providers: {
            gmail: 'Gmail',
            outlook: 'Outlook',
        },
        status: {
            active: 'Activo',
            inactive: 'Inactivo',
            error: 'Error',
            authentication_required: 'Autenticación Requerida',
        },
    },
};

